// generated from 1 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";
import { filterGetSchema } from "./filterGetSchema";

export const andNotFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("and_not_filter"),
  display_name: z.string(),
  get filters(): z.ZodArray<z.ZodType<any>> {
    return z.array(filterGetSchema);
  },
  group_name: z.string(),
  raw_value: z.null().optional(),
  varies_by_app_group: z.literal(false),
});
